import React from 'react'
import cardStyles from 'common/SearchableCard/SearchableCard.scss'
import {connect} from 'react-redux'
import {IntroWidget} from 'common/IntroWidget'
import {UserListItemContainer} from '../UserListItem'
import {TRouteItemContainer} from 'common/TRouteItem'
import {SegmentListItemContainer} from '../SegmentListItem'
import {SearchableCard} from 'common/SearchableCard'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import {CTA} from 'common/styleguide/CTA'
import styles from './PinnedList.scss'
import * as favoritesActions from 'lib/api/favorites'
import {DEFAULT_PER_PAGE} from 'lib/loadAllPages'

export class _PinnedList extends React.PureComponent {
  state = {
    keywords: '',
    limit: DEFAULT_PER_PAGE
  }

  onKeywordChange = (e) => {
    const keywords = e.target.value
    this.setState({keywords: keywords.slice(0, 32), limit: DEFAULT_PER_PAGE})
  }

  componentDidMount () {
    const {currentUser, loadAllUserFavorites} = this.props
    // despite the fact that we do this when the Dashboard app boots up,
    // we also need to do this every time the component mounts in case
    // the user has pinned something new
    loadAllUserFavorites(currentUser.id)
  }

  loadMore = () => {
    this.setState((state) => ({limit: state.limit + DEFAULT_PER_PAGE}))
  }

  render () {
    /*
    I'd like to move away from using sparseRoutes. The sparseRoutes Route
    representation is actually just a normal Record.Route, but with null
    trackPoints. This introduces the burden of keeping sparseRoutes in sync
    with any edits that may have been made to a full Route that is managed
    by lib/api/routes.

    Instead, I would like to refactor our routes and rides code to treat
    trackPoints records as a first-class data object, with their own reducer and
    internal representation format. This dovetails nicely with our conversations
    about using a draftjs style opaque data format for route geometries,  in
    order to better keep cuePoints/trackPoints in sync.
    */
    const {favorites, favoritesLoaded, sparseRoutes, sparseTrips, users, segments} = this.props
    const {keywords, limit} = this.state

    if (!favoritesLoaded && (!favorites || favorites.length === 0)) {
      return (
        <IntroWidget large i='md-pin'>
          Loading your pinned items
          <br /><CircleSpinner size={18} />
        </IntroWidget>
      )
    }

    const renderFav = f => {
      switch (f.itemType) {
        case 'route':
          return sparseRoutes.get(f.itemId) && <TRouteItemContainer key={f.id} r={sparseRoutes.get(f.itemId)} pinnedAt={f.createdAt} pinnable pinned={f.createdAt} source={f.source} />
        case 'trip':
          return sparseTrips.get(f.itemId) && <TRouteItemContainer key={f.id} r={sparseTrips.get(f.itemId)} pinnedAt={f.createdAt} pinnable pinned={f.createdAt} source={f.source} />
        case 'user':
          return users.get(f.itemId) && <UserListItemContainer key={f.id} user={users.get(f.itemId)} pinnedAt={f.createdAt} pinnable pinned={f.createdAt} />
        case 'segment':
          return segments.get(f.itemId) && <SegmentListItemContainer key={f.id} segment={segments.get(f.itemId)} pinnedAt={f.createdAt} pinnable pinned={f.createdAt} />
        default:
          console.warn(`encountered unknown favorite type ${f.itemType}`)
          return null
      }
    }

    const favSearch = keywords => f => {
      try {
        const kw = keywords.toLowerCase()
        switch (f.itemType) {
          case 'route':
            return sparseRoutes.get(f.itemId).name.toLowerCase().includes(kw)
          case 'trip':
            return sparseTrips.get(f.itemId).name.toLowerCase().includes(kw)
          case 'user':
            return users.get(f.itemId).name.toLowerCase().includes(kw)
          case 'segment':
            return segments.get(f.itemId).slug.toLowerCase().includes(kw)
          default:
            console.warn(`encountered unknown favorite type ${f.itemType}`)
            return false
        }
      } catch (e) {
        console.warn('encountered error attempting to check name of pinned item:')
        console.warn(e)
      }
    }

    const matches = keywords
      ? favorites.filter(favSearch(keywords))
      : favorites
    const toShow = matches.slice(0, limit)

    return (
      <SearchableCard
        keywords={keywords}
        onKeywordChange={this.onKeywordChange}>
        {toShow.valueSeq().map(f => renderFav(f))}
        {toShow.size === 0 && !keywords &&
          <IntroWidget large i='md-pin' link={<a href='/find'>Browse Routes</a>}>
            Items you pin for later while browsing the site will show up here.
          </IntroWidget>}
        {toShow.size === 0 && keywords &&
          <IntroWidget large i='md-pin' className={styles.IntroWidget}>
            No items matched your search
          </IntroWidget>}
        {matches.count() > toShow.count() &&
          <div className={cardStyles.resultsFooter}>
            <CTA inline secondary margins={false} onClick={() => this.loadMore()}>
              Load more
            </CTA>
            <div style={{ paddingTop: '20px' }}>
              <span className={cardStyles.footerText}>Showing 1 - {toShow.count()} of {matches.count()} results</span>
            </div>
          </div>}
        {matches.count() === toShow.count() &&
          toShow.count() > DEFAULT_PER_PAGE &&
          <div className={cardStyles.resultsFooter}>
            <span className={cardStyles.footerText}>No more items to display</span>
          </div>}
      </SearchableCard>
    )
  }
}

const mapStateToProps = state => ({
  favoritesLoaded: !state.favorites.get('loadPending'),
  favorites: state.favorites.get('favorites'), // todo filter by user id
  sparseRoutes: state.sparseRoutes,
  sparseTrips: state.sparseTrips,
  users: state.apiv3.user,
  segments: state.segments.get('segments')
})

const mapDispatchToProps = (dispatch, _) => ({
  loadAllUserFavorites: (userId) => dispatch(
    favoritesActions.loadAllUserFavorites(
      userId,
      {object_types: JSON.stringify(['Route', 'Trip', 'User', 'Segment'])}
    )
  )
})

export const PinnedList = connect(
  mapStateToProps,
  mapDispatchToProps
)(_PinnedList)
